import type { IEnvironment, MutationConfig, MutationParameters } from 'relay-runtime';
import { commitMutation as relayCommitMutation } from 'relay-runtime';

import { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

export const commitMutation = <TMutation extends MutationParameters>(
	relayEnvironment: IEnvironment,
	mutation: MutationConfig<TMutation>,
): Promise<TMutation['response']> =>
	new Promise((resolve, reject) => {
		relayCommitMutation<TMutation>(relayEnvironment, {
			...mutation,
			onCompleted: (response, errors) => {
				if (errors) {
					reject(
						new ApolloErrorInterop({
							graphQLErrors: errors.map((error) => ({ ...error, path: error.path?.map(String) })),
						}),
					);
				}
				resolve(response);
			},
			onError: (error) => {
				reject(error);
			},
		});
	});
